import { extend } from "lodash";
import { Campaign } from "..";
import { GigType, GigTypeProperty } from "../collaborations";

export enum ScreeningQuestionType {
    TEXT = 'text',
    BINARY = 'binary',
    CHOICE = 'choice'
}

export interface UnsavedScreeningQuestion {
    question: string,
    type: ScreeningQuestionType,
    options?: string[]
}

export interface ScreeningQuestion extends UnsavedScreeningQuestion {
    id: number,
    campaign_id: number,
}

export interface CampaignDetailsSlice {
    loading: boolean,
    error: string | null,
    screeningQuestions: Record<string, {questions: ScreeningQuestion[], last_fetched_at: number}>,
    campaigns: Record<string, {campaign: Campaign, properties: GigTypeProperty[], gig_types: GigType[], goal_list: Record<string, CampaignGoal>, last_fetched_at: number}>
}


export interface CampaignGoal {
    label: string,
    description: string
}